import React, { useEffect } from 'react';

import { useHistory, useParams } from "react-router-dom";

import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import PeopleIcon from '@material-ui/icons/People';
import SettingsIcon from '@material-ui/icons/Settings';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import LinkIcon from '@material-ui/icons/Link';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';

import FeesTab from './CoupleDetail/FeesTab';
import ProfileTab from './CoupleDetail/ProfileTab';
import SettingsTab from './CoupleDetail/SettingsTab';
import WeddingTab from './CoupleDetail/WeddingTab';
import WitnessesTab from './CoupleDetail/WitnessesTab';

import SaveButton from './CoupleDetail/SaveButton';


const isApproved = (wedding) => {
    return wedding.couple_agree_date && wedding.couple_agree_date !== "0000-00-00 00:00:00";
}

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    tabs: {
        [theme.breakpoints.up('sm')]: {
            '& .MuiTab-root': {
                minWidth: 105
            }
        },
        [theme.breakpoints.down('sm')]: {
            '& .MuiTab-root': {
                minWidth: 50,
                '& .MuiTab-wrapper': {
                    fontSize: '0.80rem'
                },
                '& .MuiSvgIcon-root': {
                    fontSize: '1.3rem'
                },
            }
        },
        [theme.breakpoints.down('xs')]: {
            '& .MuiTab-root': {
                '& .MuiTab-wrapper': {
                    fontSize: '0.54rem'
                },
                '& .MuiSvgIcon-root': {
                    fontSize: '1.3rem'
                },
            }
        }
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`couple-detail-tabpanel-${index}`}
            aria-labelledby={`couple-detail-tab-${index}`}
            {...other}
        >
            <Box p={3}>{children}</Box>
        </Typography>
    );
}

function a11yProps(index) {
    return {
        id: `couple-detail-tab-${index}`,
        'aria-controls': `couple-detail-tabpanel-${index}`,
    };
}

const ApprovalTab = (props) => {
    const { couple, setCouple, isAdmin, state, handleChange } = props;

    const [formErrors, setFormErrors] = React.useState({});
    const [contracts, setContracts] = React.useState([]);
    const [informationForms, setInformationForms] = React.useState([]);

    const fetchContracts = () => {
        fetch(`/admin/couples/${couple.id}/contracts`)
        .then(response => {
            return response.json();
        })
        .then(response => {
            setContracts(response.contracts)
        });
    }

    const fetchForms = () => {
        fetch(`/admin/couples/${couple.id}/information-forms`)
        .then(response => {
            return response.json();
        })
        .then(response => {
            setInformationForms(response.forms)
        })
    }

    useEffect(() => {
        fetchContracts()
        fetchForms()
    }, [])

    const resetConsent = event => {
        const data = {
            _token: window._token
        }
        new Promise((resolve, reject) => {
            fetch(`/api/approvals/${couple.id}/reset`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    resolve();
                    setSnackbarMessage('Couple\'s consent and documents have been reset');
                    setOpenSnackbar(true);
                    setCouple(result.wedding);
                })
                .catch(reason => {
                    alert('An error prevented resetting the approvals. Please refresh the page and try again.');
                    resolve();
                });
        });
    }

    const generateApprovalData = (type) => {
        const data = {
            _token: window._token
        }
        if (type !== 'contracts' && type !== 'information-forms') {
            return
        }
        fetch(`/admin/couples/${couple.id}/${type}`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            return response.json();
        })
        .then(() => {
            if (type === 'contracts') {
                fetchContracts();
            } else {
                fetchForms();
            }
        })
        .catch(() => {
            if (type === 'contracts') {
                alert('An error prevented generating the new contract. Please refresh the page and try again.');
            } else {
                alert('An error prevented generating the new information form. Please refresh the page and try again.');
            }
        });
    }

    const confirmDelete = (type, id, date) => {
        const typeText = type.substring(0, type.length-1)
        if (confirm(`Are you sure you wish to delete the ${typeText} from ${date}?`)) {
            deleteApprovalData(type, id);
        }
    }

    const deleteApprovalData = (type, id) => {
        const data = {
            _token: window._token
        }
        if (type !== 'contracts' && type !== 'information-forms') {
            return
        }
        fetch(`/admin/couples/${couple.id}/${type}/${id}`, {
            method: 'DELETE',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            return response.json();
        })
        .then(() => {
            if (type === 'contracts') {
                fetchContracts();
            } else {
                fetchForms();
            }
        })
        .catch(() => {
            if (type === 'contracts') {
                alert('An error prevented deleting the contract. Please refresh the page and try again.');
            } else {
                alert('An error prevented deleting the information form. Please refresh the page and try again.');
            }
        });
    }

    const handleDownload = (type, id) => {
        if (type === 'contracts' || type === 'information-forms') {
            window.open(`/admin/couples/${couple.id}/${type}/${id}`);
            return;
        }
    }

    const handlePublicDownload = (type, id) => {
        if (type === 'contracts') {
            window.open(`/approval/downloads/wedding-ceremony-contract?couple_hash=${couple.hash}`);
            return;
        }
        if (type === 'information-forms') {
            window.open(`/approval/downloads/couple-information-form?couple_hash=${couple.hash}`);
            return;
        }
    }

    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography>Couple's Information Form</Typography>
                <Box mt={1} mb={2}>
                    <Button endIcon={<LinkIcon />} size="small" variant="outlined" onClick={() => handlePublicDownload('information-forms')}>Public Download Link</Button>
                </Box>
                {informationForms.length > 0 && (
                    <table style={{ width: 500, maxWidth: '100%'}}>
                        <tbody>
                        {informationForms.map(form => {
                            return (
                                <tr key={`forms-${form.id}`}>
                                    <td><Typography variant='body2'>{form.date_formatted}</Typography></td>
                                    <td align="right">
                                        <IconButton size="small" aria-label="close" color="inherit" onClick={() => handleDownload('information-forms', form.id)}>
                                            <GetAppRoundedIcon fontSize="small" />
                                        </IconButton>
                                        {isAdmin && (
                                            <IconButton size="small" aria-label="close" color="secondary" onClick={() => confirmDelete('information-forms', form.id, form.date_formatted)}>
                                                <DeleteOutlineIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                )}
                {isAdmin && (
                    <Box mt={2}>
                        <Button size="small" variant="outlined" onClick={() => generateApprovalData('information-forms')}>
                            Generate New Information Form
                        </Button>
                    </Box>
                )}
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Typography>Wedding Ceremony Contract</Typography>
                <Box mt={1} mb={2}>
                    <Button endIcon={<LinkIcon />} size="small" variant="outlined" onClick={() => handlePublicDownload('contracts')}>Public Download Link</Button>
                </Box>
                {contracts.length > 0 && (
                    <table style={{ width: 500, maxWidth: '100%'}}>
                        <tbody>
                        {contracts.map(contract => {
                            return (
                                <tr key={`contract-${contract.id}`}>
                                    <td><Typography variant='body2'>{contract.date_formatted}</Typography></td>
                                    <td align="right">
                                        <IconButton size="small" aria-label="close" color="inherit" onClick={() => handleDownload('contracts', contract.id)}>
                                            <GetAppRoundedIcon fontSize="small" />
                                        </IconButton>
                                        {isAdmin && (
                                            <IconButton size="small" aria-label="close" color="secondary" onClick={() => confirmDelete('contracts', contract.id, contract.date_formatted)}>
                                                <DeleteOutlineIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                )}
                {isAdmin && (
                    <Box mt={2}>
                        <Button size="small" variant="outlined" onClick={() => generateApprovalData('contracts')}>
                            Generate New Contract
                        </Button>
                    </Box>
                )}
            </Grid>
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                {isApproved(couple) &&
                    <Typography>This wedding contract was approved on {couple.couple_agree_date_formatted}.</Typography>
                }
                {!isApproved(couple) &&
                    <Typography>This wedding contract has not yet been approved. <a href={`/approval/form?couple_hash=${couple.hash}`} target="_blank">Click here</a> to approve in person.</Typography>
                }
            </Grid>
            <Grid item xs={12}>
                <Typography color={!isAdmin ? "textSecondary" : "textPrimary"}>
                    <Button disabled={!isAdmin} size="small" color="primary" variant="outlined" onClick={resetConsent}>Click here</Button>
                    &nbsp;to reset this couple's consent and their documents.
                </Typography>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                    message={snackbarMessage}
                    action={
                        <React.Fragment>
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackbar}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox color="primary" id="no-confirmation-email" checked={!state.no_confirmation_email} onChange={handleChange('no_confirmation_email')} />
                        }
                        label='Send a confirmation email after couple completes the contract forms'
                    />
                </FormGroup>
            </Grid>
            <Grid item xs={12} sm={4}>
                <SaveButton
                    state={state}
                    coupleId={couple.id}
                    setCouple={setCouple}
                    setFormErrors={setFormErrors}
                />
            </Grid>
        </Grid>
    );
};


const CoupleDetailTabs = (props) => {
    const { couple, setCouple, officiants } = props;
    const [currentTab, setTab] = React.useState(0);
    const classes = useStyles();

    /* this is for controlling current tab */
    const handleTabChange = (event, newTab) => {
        setTab(newTab);
    };

    const isAdmin = window.isAdmin;

    const witnessDefaults = { first_name: '', last_name: '', city: '', address: '', province: '', postal_code: '' };
    const witness1 = couple.witnesses && couple.witnesses.witness1 ? couple.witnesses.witness1 : witnessDefaults;
    const witness2 = couple.witnesses && couple.witnesses.witness2 ? couple.witnesses.witness2 : witnessDefaults;

    const icNotesDefaults = {
        length: '', religious_or_not: '', humour_or_serious: '',
        brides_processional: '', parental_situation: '',
        readings: '', vows_write_own_or_stock: '', vows_read_or_repeat: '', needs_rehearsal: 0
    };

    const [state, setState] = React.useState({
        is_admin_form: true,
        bride_first_name: couple.bride_first_name,
        bride_last_name: couple.bride_last_name,
        bride_email: couple.bride_email,
        bride_title: couple.bride_title,
        groom_first_name: couple.groom_first_name,
        groom_last_name: couple.groom_last_name,
        groom_email: couple.groom_email,
        groom_title: couple.groom_title,
        couple_cell: couple.couple_cell,
        groom_cell: couple.groom_cell,
        couple_address_same: couple.couple_address_same,
        couple_address: couple.couple_address,
        couple_city: couple.couple_city,
        couple_province_id: couple.couple_province_id,
        couple_postal: couple.couple_postal,
        groom_address: couple.groom_address,
        groom_city: couple.groom_city,
        groom_province_id: couple.groom_province_id,
        groom_postal: couple.groom_postal,
        wedding_planner_email: couple.wedding_planner_email,
        location: couple.location,
        venue: couple.venue,
        notes: couple.notes,
        ic_notes: couple.ic_notes ? couple.ic_notes : icNotesDefaults,
        other_notes: couple.other_notes,
        couple_referred: couple.couple_referred,
        referral_vendor_venue: couple.referral_vendor_venue,
        email_list: couple.email_list,
        couple_type: couple.couple_type,
        is_active: couple.user.is_active,
        officiant_user_id: couple.officiant_user_id,
        wedding_colours: couple.wedding_colours,
        wedding_outside: couple.wedding_outside,
        wedding_date: new Date(couple.wedding_date*1000),
        wedding_type: couple.wedding_type,
        count_party: couple.count_party,
        count_ring: couple.count_ring,
        count_flower: couple.count_flower,
        witness1_first_name: witness1.first_name,
        witness1_last_name: witness1.last_name,
        witness1_city: witness1.city,
        witness1_address: witness1.address,
        witness1_province: witness1.province,
        witness1_postal_code: witness1.postal_code,
        witness2_first_name: witness2.first_name,
        witness2_last_name: witness2.last_name,
        witness2_city: witness2.city,
        witness2_address: witness2.address,
        witness2_province: witness2.province,
        witness2_postal_code: witness2.postal_code,
        inquiry_url: couple.inquiry_url,
        no_confirmation_email: couple.no_confirmation_email,
        wedding_date_changed: false
    });

    const handleChange = name => event => {
        let value;
        if (name == 'wedding_date') {
            value = event;
        } else if (name == 'couple_address_same') {
            value = event.target.checked;
        } else if (name == 'no_confirmation_email') {
            value = !event.target.checked;
        } else if (name.indexOf('ic_notes.') > -1) {
            const nameArr = name.split('.');
            const icNotes = state.ic_notes;
            icNotes[nameArr[1]] = event.target.value;
            value = icNotes;
            name = 'ic_notes';
        } else {
            value = event.target.value;
        }
        /* if setting officiant, make sure couple_type is Pending also if needed */
        if (name == 'officiant_user_id' && (state.couple_type === 'Lead' || state.couple_type === 'Follow-Up')) {
            state.couple_type = 'Pending';
        }

        const coupleDate = couple.wedding_date;
        let stateDate;
        if (name === 'wedding_date') {
            stateDate = value ? value.getTime()/1000 : 0;
        } else {
            stateDate = state.wedding_date ? state.wedding_date.getTime()/1000 : '';
        }
        const weddingDateChanged = stateDate !== coupleDate;

        setState({
            ...state,
            wedding_date_changed: weddingDateChanged,
            [name]: value,
        })
    }

    const setCoupleHandler = (data) => {
        setCouple(data);
        setState({
            ...state,
            wedding_date_changed: false
        });
    }

    return (
        <div>
            <Tabs
                value={currentTab}
                onChange={handleTabChange}
                variant="fullWidth"
                indicatorColor="secondary"
                textColor="secondary"
                aria-label="couple detail tabs"
                className={classes.tabs}
            >
                <Tab icon={<PersonPinIcon />} label="PROFILE" {...a11yProps(0)} />
                <Tab icon={<FavoriteIcon />} label="WEDDING" {...a11yProps(1)} />
                <Tab icon={<PeopleIcon />} label="WITNESSES" {...a11yProps(2)} />
                <Tab icon={<AttachMoneyIcon />} label="FEES" {...a11yProps(3)} />
                <Tab icon={<SettingsIcon />} label="SETTINGS" {...a11yProps(4)} />
                <Tab icon={<ThumbUpIcon />} label="APPROVAL" {...a11yProps(5)} />
            </Tabs>
            <Divider />
            <TabPanel value={currentTab} index={0}>
                <ProfileTab
                    couple={couple}
                    setCouple={setCoupleHandler}
                    handleChange={handleChange}
                    state={state}
                />
            </TabPanel>
            <TabPanel value={currentTab} index={1}>
                <WeddingTab
                    officiants={officiants}
                    couple={couple}
                    setCouple={setCoupleHandler}
                    handleChange={handleChange}
                    state={state}
                />
            </TabPanel>
            <TabPanel value={currentTab} index={2}>
                <WitnessesTab
                    couple={couple}
                    setCouple={setCoupleHandler}
                    handleChange={handleChange}
                    state={state}
                />
            </TabPanel>
            <TabPanel value={currentTab} index={3}>
                <FeesTab couple={couple} />
            </TabPanel>
            <TabPanel value={currentTab} index={4}>
                <SettingsTab
                   couple={couple}
                   setCouple={setCoupleHandler}
                   handleChange={handleChange}
                   state={state}
                />
            </TabPanel>
            <TabPanel value={currentTab} index={5}>
                <ApprovalTab
                    couple={couple}
                    setCouple={setCoupleHandler}
                    handleChange={handleChange}
                    state={state}
                    isAdmin={isAdmin}
                />
            </TabPanel>
        </div>
    );
}

const CoupleDetail = () => {
    const { id } = useParams();
    const classes = useStyles();

    const [couple, setCouple] = React.useState({});
    const [officiants, setOfficiants] = React.useState([]);

    let history = useHistory();
    function handleClick() {
        window.history.back();
    }

    useEffect(() => {
        document.title = `Couple ${id} - Enduring Promises`;

        new Promise((resolve, reject) => {
            let url = `/api/couples/${id}`
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setCouple(result);
                    resolve();
                })
        });

        new Promise((resolve, reject) => {
            let url = `/api/officiants`
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setOfficiants(result);
                    resolve();
                })
        });
    }, [id]);

    return (
        <div>
            <Box mb={2}>
                <Button startIcon={<Icon>chevron_left</Icon>} size="small" onClick={handleClick} variant="outlined" color="primary">Back</Button>
            </Box>
            <Paper square>
                <Box className={classes.root}>
                    {couple.id !== undefined && <CoupleDetailTabs couple={couple} setCouple={setCouple} officiants={officiants} />}
                </Box>
            </Paper>
        </div>
    );
}

export default CoupleDetail;
